'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import NextImage from '@/features/Image'; // Assuming this is your wrapper for next/image

// Import Swiper styles directly
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

// Define the type for a single slider image for better type safety
interface SliderImage {
  photo: string;
  // Add other properties if they exist, like 'link' or 'alt_text'
}

interface BannerSliderProps {
  sliders: SliderImage[];
}

const BannerSlider: React.FC<BannerSliderProps> = ({ sliders }) => {
  const isOptimizationDisabled =
    process.env.NEXT_PUBLIC_DISABLE_IMAGE_OPTIMIZATION === 'true';

  return (
    <Swiper
      modules={[Autoplay, EffectFade]}
      effect="fade"
      fadeEffect={{ crossFade: true }}
      loop={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      speed={1000}
      className="banner-swiper"
    >
      {sliders?.map((image, index) => (
        <SwiperSlide key={index}>
          <div className="banner-slide">
            <NextImage
              src={image?.photo}
              alt={'Zepid banner image'}
              width={1920} // Desktop dimensions
              height={800}
              // The FIRST image is the most important for LCP.
              priority={index === 0}
              // CRITICAL: Add the 'sizes' prop for responsiveness
              sizes="(max-width: 768px) 100vw, 80vw"
              className="img-fluid w-100 rounded-3 banner__thumbnail"
              unoptimized={isOptimizationDisabled}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BannerSlider;
